import anyPass from "ramda/es/anyPass";
import curry from "ramda/es/curry";
import map from "ramda/es/map";
export const includeHeader = curry((include, header)=>header.includes(include));
const fileTypes = [
    'image',
    'application',
    'audio',
    'video'
];
export const includeHeaderFile = anyPass(map(includeHeader, fileTypes));
